module.exports = __webpack_public_path__ + "static/media/YF11_5.4bc82885.jpg";